import Vue from 'vue';
import Axios from 'axios';
import AxiosRetry from 'axios-retry';

const axios = Axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
        },
    },
});

// 2 reties = 3 tries in total.
AxiosRetry(axios, { retries: 2 });

Vue.prototype.$axios = axios;

export default axios;
